import {responseToData} from 'shared/utils/data-service-utils';
import type {AnyObject} from 'typings/portaro.fe.types';
import type {ViewableFile} from 'typings/portaro.be.types';

// uses package 'ng-file-upload'
export class FileUploadService {
    public static serviceName = 'fileUploadService';

    /*@ngInject*/
    constructor(private Upload) {}

    public async upload(url: string, file: File, data?: AnyObject): Promise<ViewableFile> {
        const request = {
            url,
            data: {...data, ...{fileData: file}},
        };
        const response = await this.Upload.upload(request);
        return responseToData(response);
    }
}